import { Button } from '@/components/ui/button';
import { Calendar, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

interface MobileStickyCTAProps {
  variant?: 'booking' | 'message' | 'find';
  onAction?: () => void;
  therapistId?: string;
}

export const MobileStickyCTA = ({ variant = 'find', onAction, therapistId }: MobileStickyCTAProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Don't show on certain pages
  const hiddenPaths = ['/client-portal', '/therapist-portal', '/booking', '/checkout'];
  if (hiddenPaths.some(path => location.pathname.includes(path))) {
    return null;
  }

  const handleAction = () => {
    if (onAction) {
      onAction();
    } else {
      switch (variant) {
        case 'booking':
          if (therapistId) {
            navigate(`/booking/${therapistId}`);
          }
          break;
        case 'message':
          // Scroll to contact or open message
          break;
        case 'find':
        default:
          navigate('/find');
          break;
      }
    }
  };

  const getButtonText = () => {
    switch (variant) {
      case 'booking':
        return 'Book Session';
      case 'message':
        return 'Send Message';
      case 'find':
      default:
        return 'Find Therapist';
    }
  };

  const getIcon = () => {
    switch (variant) {
      case 'booking':
        return <Calendar className="h-5 w-5" />;
      case 'message':
        return <MessageCircle className="h-5 w-5" />;
      case 'find':
      default:
        return <Calendar className="h-5 w-5" />;
    }
  };

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-background/95 backdrop-blur-lg border-t-2 border-primary/20 shadow-2xl"
    >
      <div className="container mx-auto px-4 py-3">
        <Button
          size="lg"
          className="w-full text-base py-6 shadow-lg"
          onClick={handleAction}
        >
          {getIcon()}
          <span className="ml-2">{getButtonText()}</span>
        </Button>
      </div>
    </motion.div>
  );
};
